import React, { useEffect } from 'react';

import { Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { mypageWrapper } from '../../../constants/Location';
import { screenType } from '../../../constants/enum';
import MypageMediaCompare from '../../uiParts/MediaCompare';
import Sidebar from '../../uiParts/Sidebar';

const styles = {
  mypageWrapper
};

const ClientMypageMediaCompare: React.FC = () => {
  const { t } = useTranslation();

  useEffect(() => {
    document.title = t('title.client.mediaCompare');
  });

  const url = new URL(window.location.href);
  const param = url.searchParams;
  const mediaIds = param.get('mediaIds')?.split('?').join('') ?? '';
  const mediaList = mediaIds.split(',');

  return (
    <>
      <Typography sx={styles.mypageWrapper} component="div">
        <Sidebar screenType={screenType.client} />
        <MypageMediaCompare medias={mediaList} screen={screenType.client} />
      </Typography>
    </>
  );
};

export default ClientMypageMediaCompare;
